import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "add-price-track-page",
  class: "page add-price-track-page"
}
const _hoisted_2 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_AppUploader = _resolveComponent("AppUploader")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers(_ctx.addPriceTrack, ["prevent"]),
                    class: "py-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "d-flex align-center text-center justify-space-between mb-6" }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("span", { class: "text-h5" }, " Add PriceTrack ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Name", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Fund Name to appear in the report",
                            modelValue: _ctx.priceTrackObject.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceTrackObject.name) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Select Index", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_autocomplete, {
                            "data-testid": "Index-Type-List",
                            modelValue: _ctx.indexType,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.indexType) = $event)),
                            items: _ctx.indexTypes,
                            "item-title": "name",
                            "item-value": "id",
                            class: "mx-0 mt-2 mb-5",
                            type: "text",
                            "hide-no-data": "",
                            "hide-details": "",
                            label: "Index Type",
                            variant: "filled"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("First Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Start Date",
                            modelValue: _ctx.priceTrackObject.firstDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceTrackObject.firstDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Calculate granular past performance: ${_ctx.priceTrackObject.calculatePastPerformance.toString()}`,
                            modelValue: _ctx.priceTrackObject.calculatePastPerformance,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.priceTrackObject.calculatePastPerformance) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode("Date Distribution", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_select, {
                            "hide-details": "",
                            items: ['Monthly'],
                            variant: "underlined",
                            "persistent-hint": false,
                            modelValue: _ctx.priceTrackObject.dateDistribution,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.priceTrackObject.dateDistribution) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("NAV Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            variant: "underlined",
                            "persistent-hint": false,
                            placeholder: "Should be present in the price track that you upload",
                            modelValue: _ctx.priceTrackObject.navDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.priceTrackObject.navDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Are charges included in the uploaded price track: ${_ctx.priceTrackObject.chargesIncluded.toString()}`,
                            modelValue: _ctx.priceTrackObject.chargesIncluded,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.priceTrackObject.chargesIncluded) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Allow short contribution history in the member simulation: ${_ctx.priceTrackObject.includeShortContributionHistory.toString()}`,
                            modelValue: _ctx.priceTrackObject.includeShortContributionHistory,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceTrackObject.includeShortContributionHistory) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("Fund Charges (Percentage %)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Enter decimal number",
                            type: "number",
                            modelValue: _ctx.priceTrackObject.charge,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.priceTrackObject.charge) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_AppUploader, {
                            "data-testid": "FileUpload",
                            onAppUploader: _ctx.handleFile,
                            disabled: _ctx.addingPriceTrack,
                            fileType: '.csv'
                          }, null, 8, ["onAppUploader", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            "data-testid": "SubmitUploadBtn",
                            color: _ctx.addingPriceTrack ? 'disabled' : 'success',
                            type: "submit",
                            loading: _ctx.addingPriceTrack,
                            disabled: _ctx.addingPriceTrack,
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("Add", -1)
                            ]))]),
                            _: 1
                          }, 8, ["color", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}